module.exports = __webpack_public_path__ + "img/logo.22ba8475.png";